"use client";
import { FC, MouseEvent } from "react";

import { Animation } from "../../../../gql/generated/graphql";
import config from "../../../../lib/config";

type VideoProps = {
  animation: Pick<
    Animation,
    "id" | "encoded" | "schemaVersion" | "url" | "version"
  >;
};

export const Video: FC<VideoProps> = ({ animation }) => {

  const onAnimationLoadError = () => {
    const hasVideo =
      !!document.createElement("video").canPlayType &&
      !!document.createElement("video").canPlayType("video/mp4");

    if (!hasVideo) return;
    if (animation.encoded) return; // no need to request encode

  };

  if (!animation.url) return null;

  const posterPath =
    animation.schemaVersion > 1
      ? `${config.s3Path}/${animation.url}/poster.png?v=${animation.version}`
      : `${config.s3Path}/${animation.url}/0.png?v=${animation.version}`;

  return (
    <video
      loop
      autoPlay
      playsInline
      muted
      key={animation.id}
      poster={posterPath}
      onError={onAnimationLoadError}
      onClick={(e: MouseEvent<HTMLVideoElement>) => {
        const el = e.currentTarget;
        if (el.paused) {
          el.play();
        } else {
          el.pause();
        }
      }}
    >
      <source
        src={`${config.s3Path}/${animation.url}/animation.mp4?v=${animation.version}`}
        type="video/mp4"
      />
    </video>
  );
};
